var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 0H0V300H300V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23_1474)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.5 0.5V299.5H0.5V0.5H299.5Z",
    fill: "white",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.0267 69.6619C98.9677 69.5139 100.986 69.5879 102.933 69.6239C107.152 69.7179 111.368 69.9149 115.577 70.2129C139.647 71.6989 163.393 76.4489 187.506 77.4309C207.715 78.2539 227.857 76.8669 247.987 75.2809C255.059 74.6819 262.137 74.1469 269.219 73.6759C272.302 73.4729 275.397 73.1859 278.485 73.1179L278.514 211.402C272.787 211.127 266.957 211.311 261.218 211.306L227.606 211.354L41.5626 211.428C41.4086 206.32 41.5347 201.178 41.5387 196.066L41.5317 167.636L41.5197 76.3539C44.8937 75.7489 48.3347 75.3279 51.7237 74.7889C58.9427 73.6409 66.1157 72.4229 73.3807 71.5679C81.2427 70.6419 89.1237 70.1269 97.0267 69.6619Z",
    fill: "#A03639"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 300,
    height: 300
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20H300V320H0V20Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.653 114.419L210.48 117.507V127.883H203.453V94.1021H210.48V108.821L219.809 94.1021H226.709L216.933 109.159L226.709 127.883H219.489L212.653 114.419Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 300,
    height: 300
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H310V300H10V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.65 127.883H231.43V94.1021H237.692V114.322L244.911 94.1021H253.728V127.883H247.403V103.416L238.65 127.883Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 300,
    height: 300
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H310V300H10V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.012 94.1021H198.734V98.9281H191.387V127.883H184.359V98.9281H177.012V94.1021Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 300,
    height: 300
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H310V300H10V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.214 127.883H149.994V94.1021H156.256V114.322L163.476 94.1021H172.293V127.883H165.968V103.416L157.214 127.883Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 300,
    height: 300
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H310V300H10V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.133 127.883H123.105V94.1021H145.275V127.883H138.119V98.9281H130.133V127.883Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 300,
    height: 300
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H310V300H10V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.35 117.169H109.123L105.736 100.086L102.35 117.169ZM118.387 127.883H111.295L110.081 121.754H101.456L100.242 127.883H93.7891L100.945 94.1021H111.231L118.387 127.883Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 300,
    height: 300
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H310V300H10V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.9294 127.883H66.9004V94.1021H73.9294V108.579H81.9154V94.1021H89.0714V127.883H81.9154V113.405H73.9294V127.883Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 300,
    height: 300
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H310V300H10V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.943 163.575H249.843V169.708H237.943V182.281H252.917V188.414H229.273V145.483H252.917V151.616H237.943V163.575Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 300,
    height: 300
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H310V300H10V0Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.51 145.481H225.306V151.614H216.242V188.412H207.573V151.614H198.51V145.481Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 300,
    height: 300
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H310V300H10V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.382 172.404V178.109C195.382 181.584 194.278 184.262 192.072 186.143C189.917 187.983 186.713 188.902 182.457 188.902C178.2 188.902 174.969 187.983 172.763 186.143C170.609 184.262 169.531 181.584 169.531 178.109V155.784C169.531 152.309 170.609 149.651 172.763 147.811C174.969 145.93 178.2 144.99 182.457 144.99C186.713 144.99 189.917 145.93 192.072 147.811C194.278 149.651 195.382 152.309 195.382 155.784V159.955H187.185V155.355C187.185 153.801 186.765 152.718 185.924 152.104C185.136 151.45 184.059 151.123 182.693 151.123C181.327 151.123 180.224 151.45 179.383 152.104C178.595 152.718 178.2 153.801 178.2 155.355V178.538C178.2 180.091 178.595 181.175 179.383 181.788C180.224 182.402 181.327 182.708 182.693 182.708C184.059 182.708 185.136 182.402 185.924 181.788C186.765 181.175 187.185 180.091 187.185 178.538V172.404H195.382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 300,
    height: 300
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H310V300H10V0Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.202 163.575H162.103V169.708H150.202V182.281H165.176V188.414H141.533V145.483H165.176V151.616H150.202V163.575Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 300,
    height: 300
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H310V300H10V0Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.26 175.962L123.172 145.481H135.23V188.412H127.033V157.624L121.043 188.412H112.847L106.384 158.053V188.412H98.8184V145.481H110.877L117.26 175.962Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_23_1474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H300V300H0V0Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_23_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5479 151.614V162.96H78.9369C80.5659 162.96 81.8269 162.633 82.7199 161.979C83.6659 161.325 84.1379 160.139 84.1379 158.421V156.03C84.1379 154.476 83.7709 153.351 83.0349 152.656C82.3519 151.961 81.2489 151.614 79.7249 151.614H75.5479ZM75.5479 169.093V182.279H80.5129C81.9839 182.279 83.0879 181.972 83.8229 181.359C84.6109 180.746 85.0049 179.642 85.0049 178.047V174.306C85.0049 172.302 84.5589 170.933 83.6659 170.197C82.8249 169.461 81.4059 169.093 79.4099 169.093H75.5479ZM79.9619 145.481C84.4799 145.481 87.7379 146.298 89.7339 147.934C91.7829 149.57 92.8079 152.043 92.8079 155.355V156.888C92.8079 159.096 92.3609 160.916 91.4679 162.347C90.5749 163.777 89.1559 164.841 87.2119 165.536C89.5759 166.231 91.2309 167.375 92.1769 168.97C93.1759 170.524 93.6749 172.446 93.6749 174.735V178.231C93.6749 181.543 92.5709 184.078 90.3649 185.836C88.1579 187.553 84.8739 188.412 80.5129 188.412H66.8789V145.481H79.9619Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.451ec7680cf2975bf18d755068bdb0f9.svg";
export { ForwardRef as ReactComponent };